// Der Titel der Seite beim Drucken (seit E3b, O76): Chrome und Edge nehmen
// ihn als Namen fürs PDF („Als PDF speichern“). Während des Druckens heißt
// die Seite wie die Datei, die daraus wird; danach gilt wieder ihr Titel.
// Benutzt von der Unterlage (bis E3c auch von den Materiallisten des
// Lagers). Wie die Namen gebaut sind: freigabe/dachplanung.ts.

import { useEffect } from "react";

export function useDruckTitel(name: string): void {
  useEffect(() => {
    let vorher = document.title;
    const vor = () => {
      vorher = document.title;
      document.title = name;
    };
    const nach = () => {
      document.title = vorher;
    };
    window.addEventListener("beforeprint", vor);
    window.addEventListener("afterprint", nach);
    return () => {
      window.removeEventListener("beforeprint", vor);
      window.removeEventListener("afterprint", nach);
    };
  }, [name]);
}
